<template>
  <div
    v-if="isClient && !isPlusUser"
    class="min-w-100px h-100 mx-3 d-flex align-items-center"
  >
    <button
      @click.prevent="onPressUpgrade"
      class="btn upgrade-button px-5 position-relative"
    >
      <div class="position-relative me-4">
        <span class="font-weight-bold">Upgrade To Plus</span>

        <inline-svg
          class="position-absolute plus-star"
          style="width: 16px; top: -5px; inset-inline-end: -16px"
          src="/img/plus/plus_star_white.svg"
        />
      </div>

      <div class="icon-wrapper">
        <span class="svg-icon white-icon m-0 pb-1">
          <v-icon size="18" color="#000000" class="icon-rotated" dense
            >mdi-arrow-down</v-icon
          >
        </span>
      </div>
      <!--      <span class="ms-2 svg-icon">-->
      <!--        <v-icon size="18">mdi-arrow-top-right-thin-circle-outline</v-icon>-->
      <!--      </span>-->
    </button>

    <SubscriptionPopup
      v-if="isClient && !isPlusUser"
      ref="subscriptionPopup"
      @showSuccessModal="showSuccessModal"
    />
    <SuccessModal ref="successModal" />
  </div>
</template>

<script>
// import { mdiTagArrowUp } from '@mdi/font/css';
import { mapGetters } from "vuex";
import SubscriptionPopup from "@/own/components/IqfPlus/SubscriptionPopup.vue";
import SuccessModal from "@/own/components/IqfPlus/SuccessModal.vue";

export default {
  name: "UpgradeToPlus",
  components: {
    SubscriptionPopup,
    SuccessModal,
  },
  // data: function () {
  //   return {
  //     warehouse: null,
  //   };
  // },
  // mounted() {
  //   this.warehouse = this.$store.getters.getSelectedWarehouse;
  //   // console.log("this.warehouse", this.warehouse);
  // },
  computed: {
    ...mapGetters(["isClient", "isPlusUser"]),
    // selectedWarehouse: function () {
    //   return this.$store.getters.getSelectedWarehouse;
    // },
  },
  methods: {
    onPressUpgrade() {
      this.$refs.subscriptionPopup.toggleModal();
      // console.log(".warehouse", value);
    },
    showSuccessModal() {
      this.$refs.successModal.toggleModal();
    },
  },
};
</script>

<style scoped lang="scss">
.plus-star {
  //color: #7e8299 !important;
  //svg {
  fill: #fff !important;
  //}
}

.upgrade-button {
  // background: #3b40ff;
  background: -webkit-linear-gradient(
    57deg,
    rgba(60, 73, 255, 1) 0%,
    rgba(125, 6, 183, 1) 70%
  );
  background: -moz-linear-gradient(
    57deg,
    rgba(60, 73, 255, 1) 0%,
    rgba(125, 6, 183, 1) 70%
  );
  background: linear-gradient(
    57deg,
    rgba(60, 73, 255, 1) 0%,
    rgba(125, 6, 183, 1) 70%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(
      startColorstr="#3B40FF",
      endColorstr="#7006AE",
      GradientType=1
  );

  //background-image: linear-gradient(
  //  to right,
  //  #6a5acd,
  //  #8a2be2
  //); /* Gradient background */
  color: white; /* White text color */
  padding: 12px 24px; /* Adjust padding for size */
  //border: 4px solid #32a1ce !important; /* Add a light gray border */
  //border-radius: 8px; /* Rounded corners */
  //border-color: rgba(59, 64, 255, 1) rgba(112, 6, 174, 1) !important;
  font-size: 16px; /* Adjust font size */
  cursor: pointer; /* Change cursor on hover */
  display: inline-flex; /* To align text and arrow */
  align-items: center; /* Vertically align items */
  gap: 8px; /* Space between text and arrow */
  transition: background-image 0.3s ease, border-color 0.3s ease; /* Smooth transition for hover effect and border */
  border: 4.5px solid #b6b6ff !important;
}

// .upgrade-button:hover {
//   background-image: linear-gradient(
//     to right,
//     #8a2be2,
//     #6a5acd
//   ); /* Reverse gradient on hover */
//   border-color: #c0c0c0; /* Slightly darker border on hover (optional) */
// }

.arrow {
  display: inline-block;
  width: 25px; /* Adjust size of the circle */
  height: 25px;
  border-radius: 50%; /* Make it a circle */
  background-color: white; /* White background for the circle */
  color: black; /* Black color for the arrow */
  font-size: 14px; /* Adjust arrow size */
  text-align: center;
  line-height: 25px; /* Vertically center the arrow */
  margin-inline-start: 12px;
}

/* You might need to add the actual arrow character or use an icon font */
.arrow::before {
  content: "↗"; /* Using a Unicode right-up arrow */
}
.icon-wrapper {
  background-color: white;
  border-radius: 50%;
  width: 20px; // or whatever size you need
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline-end: 2px;
}

.white-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-rotated {
  transform: rotate(-142deg);
}
.btn--upgrade-plus {
  color: #fff !important;
  font-size: 1.1rem;
  font-family: Poppins, Helvetica, sans-serif;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  outline: 0 !important;
  min-width: 110px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  background: linear-gradient(#3b40ff, #3b40ff) 50% 50% / calc(100% - 24px)
      calc(100% - 24px) no-repeat,
    linear-gradient(90deg, #3b40ff 0%, #7006ae 100%);
  border-radius: 8px;
  padding: 32px;
  box-sizing: content-box;
  //background: #3b40ff;
  //background: -webkit-linear-gradient(
  //  90deg,
  //  rgba(59, 64, 255, 1) 0%,
  //  rgba(112, 6, 174, 1) 100%
  //);
  //background: -moz-linear-gradient(
  //  90deg,
  //  rgba(59, 64, 255, 1) 0%,
  //  rgba(112, 6, 174, 1) 100%
  //);
  //background: linear-gradient(
  //  90deg,
  //  rgba(59, 64, 255, 1) 0%,
  //  rgba(112, 6, 174, 1) 100%
  //);
  //filter: progid:DXImageTransform.Microsoft.gradient(
  //    startColorstr="#3B40FF",
  //    endColorstr="#7006AE",
  //    GradientType=1
  //);
  //
  //border: 4px solid transparent;
  //border-radius: 6px;

  i {
    color: #fff !important;
  }
}

.btn--upgrade-plus:hover {
  background-image: linear-gradient(
    to right,
    #8a2be2,
    #6a5acd
  ); /* Reverse gradient on hover */
  border-color: #c0c0c0; /* Slightly darker border on hover (optional) */
  //background-color: rgba(126, 4, 183, 0.8) !important;
  //color: #8950fcff !important;
  //
  //i {
  //  color: #8950fcff !important;
  //}
}

.btn--upgrade-plus.btn.btn-info:hover:not(.btn-active) {
  //background-color: rgba(126, 4, 183, 0.8) !important;
  //color: #8950fcff !important;
  //
  //i {
  //  color: #8950fcff !important;
  //}
}

.btn--upgrade-plus.btn.btn-info:focus:not(.btn-active) {
  //background-color: rgba(126, 4, 183, 0.8) !important;
  //color: #8950fcff !important;
  //
  //i {
  //  color: #8950fcff !important;
  //}
}
</style>
